import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrAudioIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M7.7 10.6C9.5 10.6 11 9.2 11 7.3V3.3C11 1.5 9.5 0 7.7 0C5.9 0 4.4 1.4 4.4 3.3V7.4C4.4 9.1 5.9 10.6 7.7 10.6ZM5.8 3.3C5.8 2.3 6.6 1.4 7.7 1.4C8.8 1.4 9.6 2.2 9.6 3.3V7.4C9.6 8.4 8.8 9.3 7.7 9.3C6.6 9.3 5.8 8.5 5.8 7.4V3.3ZM13.4 8.8C13.2 10 12.5 11.1 11.5 11.9C10.6 12.6 9.6 12.9 8.4 13.1V14.8C8.4 15.2 8.1 15.5 7.7 15.5C7.3 15.5 7 15.2 7 14.8V13.1C5.9 13 4.8 12.6 3.9 11.9C2.8 11.1 2.1 10 2 8.8C2 8.5 2.2 8.1 2.6 8.1C3 8 3.3 8.3 3.4 8.7C3.5 9.5 4 10.3 4.8 10.9C5.6 11.5 6.6 11.8 7.7 11.8C8.8 11.8 9.8 11.5 10.6 10.9C11.4 10.3 11.9 9.5 12 8.7C12.1 8.3 12.4 8.1 12.8 8.1C13.2 8.1 13.4 8.5 13.4 8.8Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrAudioIconComponent;
